<div fxLayout="column">
  <div style="overflow: auto">
    <table
      style="width: 100%"
      mat-table
      class="mat-elevation-z8 simple-table"
      [dataSource]="dataSource"
      sortData
      (matSortChange)="sortData($event)"
      matSort
      [class]="classTable"
      [ngClass]="{ table__custom__center: tableCenter }"
    >
      <ng-container matColumnDef="customSelectSimpleTable" *ngIf="isSelectable">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container *ngFor="let column of tableColumns; let index = index">
        <ng-container
          [matColumnDef]="column"
          *ngIf="column !== 'customSelectSimpleTable'"
        >
          <th
            mat-sort-header
            [disabled]="noSortColumn.includes(column)"
            mat-header-cell
            *matHeaderCellDef
            [hidden]="notShowColumn(column)"
            [style]="'min-width: ' + minWidthColumn + ';'"
          >
            {{ tableTitles[index] }}
          </th>
          <td mat-cell *matCellDef="let row" [hidden]="notShowColumn(column)">
            <div
              *ngIf="
                !isButtomColumn(column) &&
                !isImageColumn(column) &&
                !isUrlColumn(column) &&
                !isIconColumn(column) &&
                !isStateColumn(column)
              "
            >
              <ng-container *ngIf="!isDate(column)">{{
                row[column]
              }}</ng-container>
              <ng-container *ngIf="isDate(column)">{{
                row[column + "DateCustom"]
              }}</ng-container>
            </div>
            <div
              *ngIf="
                isButtomColumn(column) &&
                !isImageColumn(column) &&
                !isUrlColumn(column)
              "
              class="container__buttom"
            >
              <div *ngIf="getButtomTextColumn(column)">
                {{ row[column] }}
              </div>
              <button
                mat-icon-button
                (click)="setEvent(column, row)"
                *ngIf="optionalContent(column, row[column])"
              >
                <div [innerHtml]="getIconColumn(column)"></div>
              </button>
            </div>
            <div *ngIf="isStateColumn(column)">
              <ng-container>
                <span class="habilitado" *ngIf="row[column]">Habilitado</span>
                <span class="deshabilitado" *ngIf="!row[column]"
                  >Deshabilitado</span
                >
              </ng-container>
            </div>
            <div
              *ngIf="
                !isButtomColumn(column) &&
                isImageColumn(column) &&
                !isUrlColumn(column)
              "
            >
              <ng-container>
                <img
                  [src]="urlServer + 'galeria/no-image.png'"
                  style="width: 80px; height: 80px"
                  *ngIf="row[column] === ''"
                />
              </ng-container>
              <ng-container>
                <img
                  [src]="'https://tarjetasf.virtualplace.online/Empresas/Galeria/'+row[column]"
                  style="width: 80px; height: 80px"
                  *ngIf="
                    row[column] !== '' &&
                    getExtension(row[column]) !== 'mp4' &&
                    path !== 'usuarios'
                  "
                />
              </ng-container>
              <ng-container>
                <video
                  [src]="'https://tarjetasf.virtualplace.online/Empresas/Galeria/'+row[column]"
                  style="width: 80px; height: 80px"
                  *ngIf="
                    row[column] !== '' &&
                    getExtension(row[column]) === 'mp4' &&
                    path !== 'usuarios'
                  "
                ></video>
              </ng-container>

              <ng-container>
                <img
                  [src]="'https://tarjetasf.virtualplace.online/Empresas/Galeria/' + row[column].urlFotoPerfil "
                  style="width: 80px; height: 80px"
                  *ngIf="
                    path === 'usuarios' && row[column].urlFotoPerfil !== null
                  "
                />

                <img
                  [src]="urlServer + 'galeria/no-image.png'"
                  style="width: 80px; height: 80px"
                  *ngIf="
                    path === 'usuarios' && row[column].urlFotoPerfil === null
                  "
                />
              </ng-container>
            </div>

            <div *ngIf="isIconColumn(column) && row[column] !== ''">
              <img
                [src]="'../../../../../assets/icons/' + row[column]"
                style="
                  width: 80px;
                  height: 80px;
                  filter: brightness(0) saturate(100%) invert(100%) sepia(100%)
                    saturate(0%) hue-rotate(264deg) brightness(102%)
                    contrast(102%);
                "
                *ngIf="row[column] !== ''"
              />
            </div>

            <div *ngIf="!isButtomColumn(column) && isUrlColumn(column)">
              <ng-container *ngIf="getExtension(row[column]) === 'pdf'">
                <a
                  [href]="'https://tarjetasf.virtualplace.online/Empresas/Galeria/' + row[column]"
                  target="_blank"
                  style="color: #fff !important"
                  ><img
                    [src]="urlServer + 'galeria/pdf-ico.png'"
                    style="width: 80px; height: 80px"
                /></a>
              </ng-container>
              <ng-container *ngIf="getExtension(row[column]) !== 'pdf'">
                <a
                  [href]="row[column]"
                  target="_blank"
                  style="color: #fff !important"
                  >Ir al enlace</a
                >
              </ng-container>
            </div>
          </td>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
  </div>
  <div *ngIf="dataSource.data.length === 0" class="empty-table">
    No se encontró información
  </div>
  <mat-paginator
    [pageSizeOptions]="[10, 20, 50, 100]"
    showFirstLastButtons
  ></mat-paginator>
</div>
